import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import RoundedTitle from '../RoundedTitle';
import ContextualMenu from '../ContextualMenu';

class BoxWithTitle extends React.Component {
  constructor(props) {
    super(props);
    const { collapsed } = this.props;
    this.state = {
      collapsed,
      initialCollapse: collapsed
    };
  }


  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.collapsed !== prevState.initialCollapse) {
      return ({ collapsed: nextProps.collapsed, initialCollapse: nextProps.collapsed });
    }
    return ({ collapsed: prevState.collapsed });
  }

  toggleCollapse = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  }

  render() {
    const { collapsed } = this.state;
    const { title, className, children, style, fullContent, contextualMenu, description, canCollapse } = this.props;
    const classes = classnames('ap-box with-title', className, { collapsed, collapsable: canCollapse });
    const contentStyle = fullContent ? {
      paddingLeft: 0,
      paddingRight: 0
    } : null;
    return (
      <div className={classes} style={style}>
        <div className="title">
          <RoundedTitle title={title} />
          <span className="description"> {description} </span>
        </div>
        <div className="content" style={contentStyle}>
          <ContextualMenu
            items={contextualMenu}
          />
          {children}
        </div>
        {canCollapse
        && (
        <div className="collapse-action" onClick={this.toggleCollapse}>
          <FontAwesomeIcon icon={faAngleDown} />
        </div>
        )
        }
      </div>
    );
  }
}


BoxWithTitle.defaultProps = {
  className: '',
  collapsed: false,
  style: {},
  fullContent: false,
};

BoxWithTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  collapsed: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  fullContent: PropTypes.bool
};

export default BoxWithTitle;
